<template lang="pug">
    .flex.items-center
        template(v-if="GROUP !== 1")
            img.mr-2(:src="LOGOS[NAMES[GROUP]]")
        span.inline-block.font-bold.mr-1(:class="color") {{ GROUP === 1 ? 'SUPERADMIN' : NAMES[GROUP] }}
        template(v-if="GROUP !== 1")
            span.inline-block.text-white ADMIN
</template>

<script>
import { AuthorizationNameSpace, AuthorizationGetterTypes } from '@/store/authorization/types';

export default {
    name: "Logo",
    computed: {
        LOGOS() {
            return {
                HITFM: require('@/static/logos/hit.svg'),
                DFM: require('@/static/logos/dfm.svg'),
                RUSRADIO: require('@/static/logos/rusradio.svg'),
                MAXIMUM: require('@/static/logos/maximum.svg'),
                MONTECARLO: require('@/static/logos/montecarlo.svg'),
                RUTV: require('@/static/logos/rutv.svg'),   
            }
        },
        NAMES() {
            return {
                1: 'ADMIN',
                2: 'HITFM',
                3: 'DFM',
                4: 'RUSRADIO',
                5: 'MAXIMUM',
                6: 'MONTECARLO',
                7: 'RUTV',
            }
        },
        GROUP() {
            return this.$store.getters[`${AuthorizationNameSpace}/${AuthorizationGetterTypes.GetGroup}`]
        },
        color() {
            let result = ''
            if (this.GROUP !== 1) {
                if ([2, 4, 7].includes(this.GROUP)) result = 'text-red-500'
                if ([3, 5, 6].includes(this.GROUP)) result = 'text-yellow-300'
            } else {
                result = 'text-white'
            }
            return result
        },
    },
}
</script>